import { mutate } from "swr";
import { authenticatedAxios } from "lib/actions/fetcher";
import { endpointsSpeckle } from "./endpointsSpeckle";
import { endpointsAssets } from "lib/actions/endpoints/endpointsAssets";
import { SpeckleImportModel } from "../../SpeckleImportWizard/types/SpeckleImportModel";

export function speckleImport(projectId: number, model: SpeckleImportModel) {
  return authenticatedAxios
    .request<void>({
      ...endpointsSpeckle.import,
      data: {
        projectId,
        speckleConnectedAccountId: model.connectedAccountId,
        speckleProjectId: model.projectId,
        speckleModelName: model.modelName,
        speckleModelId: model.modelId,
        speckleVersionId: model.versionId,
      },
    })
    .then(async (resp) => {
      mutate(endpointsAssets.projectIngresses(projectId));
      return resp.data;
    });
}
